import { zodValidator } from "@tanstack/zod-adapter";
import { AnyZodObject } from "zod";

/**
 * `zodValidator` that also keeps the schema on the route, so the allowed search params can be
 * read at runtime (Darwin's page catalog lists them).
 */
export const searchValidator = <Schema extends AnyZodObject>(schema: Schema) =>
    Object.assign(zodValidator(schema), { schema });

export const getSearchSchema = (validateSearch: unknown): AnyZodObject | undefined => {
    const schema = (validateSearch as { schema?: unknown } | undefined)?.schema;
    return schema && typeof schema === "object" && "shape" in schema ? (schema as AnyZodObject) : undefined;
};
